import { Box, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import { QuickLinkCard } from "../QuickLinkCard";

const quickLinks = [
  {
    title: "Learn more about T-EDI Standards",
    buttonText: "Go",
    buttonLink: "https://tedistandards.com",
  },
  {
    title: "FAQ",
    buttonText: "Go",
    buttonLink: "http://tedistandards.com/faq-platform",
  },
  {
    title: "Full list of standards",
    buttonText: "Go",
    buttonLink: "https://tedistandards.com/thestandards",
  },
];

export const QuickLinksVertical = (): React.ReactElement => {
  return (
    <div style={{ margin: 30 }}>
      <Stack
        direction="column"
        spacing={1}
        divider={<Divider sx={{ borderColor: "divider" }} />}
      >
        {quickLinks.map((l) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              py: 1,
            }}
          >
            <Typography
              variant="body1"
              color="text.primary"
              sx={{ fontWeight: 500 }}
            >
              {l.title}
            </Typography>

            <Button
              role="button"
              disabled={l.buttonText !== "Go"}
              variant="contained"
              className="quick-link-btn"
              onClick={() => window.open(l.buttonLink, "_blank")}
            >
              {l.buttonText}
            </Button>
          </Box>
        ))}
      </Stack>
    </div>
  );
};

export const QuickLinks = (): React.ReactElement => {
  return (
    <div>
      <Typography variant="h2" className="ap-home-page-heading margnT40">
        Quick Links
      </Typography>
      <Grid container>
        <QuickLinkCard
          title="Full list of standards"
          buttonText="Go"
          buttonLink="https://tedistandards.com/thestandards"
        />
        <QuickLinkCard
          title="FAQ"
          buttonText="Go"
          buttonLink="http://tedistandards.com/faq-platform"
        />
        <QuickLinkCard
          title="T-EDI Standards website"
          buttonText="Go"
          buttonLink="https://tedistandards.com"
        />
      </Grid>
    </div>
  );
};
